"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const configuration_1 = require("@common/configuration");
const APP_URL = configuration_1.Configuration.appUrl();
const VACASA_IDP_DOMAIN = configuration_1.Configuration.vacasaIdpDomain();
const IDP_REDIRECT_URI = configuration_1.Configuration.idpRedirectUri();
const IDP_CLIENT_ID = configuration_1.Configuration.idpClientId();
const UNIT_APP_IDP_AUDIENCE = configuration_1.Configuration.unitsServiceConfig().audience;
const CUSTOM_SCOPES = configuration_1.Configuration.housekeeperConfig().customScopes;
const jwtDecode = require("jwt-decode");
//TODO: consider permissions from admin for request IDP token
exports.getScopesByUser = () => {
    if (CUSTOM_SCOPES) {
        return CUSTOM_SCOPES;
    }
    return "units:read units:write";
};
exports.getNonce = () => {
    let nonce = window.localStorage.getItem("tmp_key");
    if (!nonce) {
        nonce = uuid_1.v4();
    }
    window.localStorage.setItem("tmp_key", nonce);
    return nonce;
};
exports.validateResponseFromIdp = () => {
    if (exports.isIdpError()) {
        throw new Error(exports.getIdpErrorFromHash());
    }
    else if (exports.isIdTokenInHash()) {
        const nonce = window.localStorage.getItem("tmp_key");
        const nonceFromHash = jwtDecode(exports.getIdTokenFromHash());
        if (nonce === nonceFromHash.nonce) {
            window.localStorage.removeItem("tmp_key");
            return true;
        }
        throw new Error("invalid response from IDP");
    }
};
const IDP_QUERY_PARAMS = `directory_hint=email&client_id=${IDP_CLIENT_ID}&response_type=token+id_token&redirect_uri=${IDP_REDIRECT_URI}&scope=${exports.getScopesByUser()}&audience=${UNIT_APP_IDP_AUDIENCE}`;
const IDP_LOGOUT_URL = `${VACASA_IDP_DOMAIN}/logout?redirect_uri=${IDP_REDIRECT_URI}`;
exports.getIdpAuthorizeUrl = () => `${VACASA_IDP_DOMAIN}/authorize?${IDP_QUERY_PARAMS}&state=${uuid_1.v4()}&nonce=${exports.getNonce()}`;
exports.getEmployeeIdpAuthorizeUrl = () => exports.getIdpAuthorizeUrl().replace("directory_hint=email", "directory_hint=onelogin");
exports.getIdpRefreshUrl = () => `${exports.getEmployeeIdpAuthorizeUrl()}&prompt=none`;
exports.redirectToIdp = (info) => {
    if (window.location.href.includes("mock-idp"))
        return false;
    if (window.location.href.includes("error"))
        return false;
    if (window.location.hash && window.location.hash.includes("access_token"))
        return false;
    if (configuration_1.Configuration.environment() === configuration_1.Configuration.LOCAL && configuration_1.Configuration.localAuthToken())
        return false;
    if (configuration_1.Configuration.environment() === configuration_1.Configuration.LOCAL) {
        window.location = exports.getIdpAuthorizeUrl();
    }
    else {
        window.location = exports.getEmployeeIdpAuthorizeUrl();
    }
};
exports.redirectToHome = () => {
    window.location = APP_URL;
};
exports.isIdpError = () => window.location.href.includes("?error");
exports.isValidUrlForRedirect = (currentUrl) => {
    return currentUrl ? IDP_REDIRECT_URI === currentUrl : true;
};
exports.isSearchForward = () => window.location.href.includes("/forward");
exports.logoutToIdp = () => {
    window.location = IDP_LOGOUT_URL;
};
exports.isTokenInHash = () => {
    const hash = window.location.hash.substring(1);
    return hash.includes("access_token");
};
exports.getTokenFromHash = () => {
    const hash = window.location.hash.substring(1);
    const token = hash.split("=")[1].split("&")[0];
    return token;
};
exports.isIdTokenInHash = () => {
    const hash = window.location.hash.substring(1);
    return hash.includes("id_token");
};
exports.getIdpErrorFromHash = () => {
    const hash = window.location.href;
    try {
        let error = hash.split("=")[1].split("&")[0];
        error += " " + hash.split("=")[2].split("&")[0];
        return error;
    }
    catch (_a) {
        return hash;
    }
};
exports.getIdTokenFromHash = () => {
    const hash = window.location.hash.substring(1);
    const token = hash.split("=")[3].split("&")[0];
    return token;
};
//# sourceMappingURL=idp.js.map